<template>
    <div :id="name" role="tabpanel" class="tab-pane">
        <slot></slot>
    </div>
</template>

<script type="text/babel">
export default {
    props: ['name'],
}
</script>
